import Dashboard from "layouts/dashboard";
import Locations from "layouts/locations";
import SignIn from "layouts/authentication/sign-in";
import Icon from "@mui/material/Icon";
import Users from "layouts/users";
import Settings from "layouts/settings";
import PaymentHistory from "layouts/paymenthistory";
import ProtectedRoute from "components/ProtectedRoute";
import ScratchCards from "layouts/scratchcards";
import StaffCreation from "layouts/staffs";

// Get the user object from localStorage and retrieve the role
const user = JSON.parse(localStorage.getItem("user")); // Parse the string into an object
const userRole = user ? user.role : null; 
let routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <ProtectedRoute><Dashboard /></ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Appointments",
    key: "appointments",
    icon: <Icon fontSize="small">event_available</Icon>,
    route: "/appointments",
    component: <ProtectedRoute><Locations /></ProtectedRoute>,
  },
  {
    type: "route",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "route",
    route: "/scratchcards",
    component: <ScratchCards />,
  },
];

// Dynamically modify routes based on role
if (userRole === "admin") {
  // For admin, only show Dashboard and Appointments
  routes = routes.filter(route => route.key === "dashboard" || route.key === "appointments");
} else if (userRole === "superadmin") {
  // For superadmin, add more routes
  routes = [
    ...routes,
    {
      type: "collapse",
      name: "Users",
      key: "users",
      icon: <Icon fontSize="small">groups</Icon>,
      route: "/users",
      component: <ProtectedRoute><Users /></ProtectedRoute>,
    },
    {
      type: "collapse",
      name: "Payment History",
      key: "paymenthistory",
      icon: <Icon fontSize="small">history</Icon>,
      route: "/paymenthistory",
      component: <ProtectedRoute><PaymentHistory /></ProtectedRoute>,
    },
    {
      type: "collapse",
      name: "Appointment Amount",
      key: "appointmentAmount",
      icon: <Icon fontSize="small">currency_rupee</Icon>,
      route: "/appointmentAmount",
      component: <ProtectedRoute><Settings /></ProtectedRoute>,
    },
    // Add the Staff Creation route for superadmin
    {
      type: "collapse",
      name: "Staff Creation",
      key: "staffcreation",
      icon: <Icon fontSize="small">person_add</Icon>, // You can use any icon you prefer
      route: "/staffcreation",
      component: <ProtectedRoute><StaffCreation /></ProtectedRoute>,
    },
  ];
}

export default routes;
